export default class Revisal {

    static bless( data: any ) {
        return ( data && new Revisal(data.rank, data.amount) );
    }

    constructor( public rank: string,
                 public amount: number ) {
    }

    get tax(): boolean {
        return /\.tax$/.test( this.rank );
    }

}



/** WEBPACK FOOTER **
 ** ./src/models/Revisal.ts
 **/